import { SONLLink } from "./SONLLink";
import { SPPGuideLink } from "./SPPGuideLink";

export const UW_NOTE_TOKENS = {
  "[SONL]": SONLLink,
  "[SPP_GUIDE]": SPPGuideLink,
};
